export default (function (_temp) {
  let {
    description = 'rails'
  } = _temp === void 0 ? {} : _temp;
  const eventbus = document.createComment(description);
  document.appendChild(eventbus);
  return {
    on: (type, listener) => {
      eventbus.addEventListener(type, listener);
    },
    once: (type, listener) => {
      eventbus.addEventListener(type, listener, {
        once: true
      });
    },
    off: (type, listener) => {
      eventbus.removeEventListener(type, listener);
    },
    emit: (type, detail) => eventbus.dispatchEvent(new CustomEvent(type, {
      detail
    }))
  };
});